/** @badge Custom — токенный враппер над Iconify-иконкой кита (не telegram-ui напрямую)
 *  @when   любая пиктограмма с токенным размером/цветом: в Button.before, Cell, Badge
 *  @not    интерактивная иконка-кнопка — это IconButton (там haptic и hit-area)
 *  @breaks неизвестное/незагруженное имя рендерится в null — пусто, без ошибки в консоли
 */
"use client";

import KitIcon from "../icons/Icon";
import { icon as tokens } from "@/lib/tokens";

type IconSize = keyof typeof tokens.size;
type IconColor = keyof typeof tokens.color;

interface IconProps {
  name: string;
  size?: IconSize;
  color?: IconColor;
  fill?: boolean;
  style?: React.CSSProperties;
}

/**
 * Icon — Token-aware wrapper over kit Icon (Iconify)
 * Pass icon name: "rocket", "solar:rocket-bold-duotone", "ri:ai-generate"
 */
export function Icon({
  name,
  size = "md",
  color = "default",
  fill = false,
  style,
}: IconProps) {
  const s = tokens.size[size];
  const c = tokens.color[color];

  return (
    <KitIcon
      name={name}
      size={s}
      style={{ color: c, fill: fill ? c : undefined, ...style }}
    />
  );
}
